import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import * as d3 from 'd3';
@Component({
    selector: 'app-legend-color-scale',
    templateUrl: './legend-color-scale.component.html',
    styleUrls: ['./legend-color-scale.component.css']
})
export class LegendColorScaleComponent implements AfterViewInit, OnInit {

  constructor() { }

  @Input() public legendConfiguration:
    {
      color: string;
      textShown: string;
      id: string;
      legendType: string;
    };

  @Input() legendData: Array<any>;

  ngOnInit() {
    this.showColorLegend();
  }
  ngAfterViewInit() {
    this.showColorLegend();
  }

  showColorLegend() {
    switch (this.legendConfiguration.legendType) {
      case 'rect':
        this.rectLegend();
        break;

      case 'circle':
        this.circleLegend();
        break;
    }
  }

  rectLegend() {
    const width = 300;
    const height = 77;
    const id = '#' + this.legendConfiguration.id;
    const legendText = d3.set(this.legendData.map(item => item[this.legendConfiguration.textShown])).values();
    const legendColor = d3.set(this.legendData.map(item => item[this.legendConfiguration.color])).values();
    const color = d3.scaleOrdinal()
      .domain(legendText)
      .range(legendColor);

    const svgLegned4 = d3.select(id).append('svg')
      .attr('width', width)
      .attr('height', height - 50);

    let dataL = 0;
    const offset = 80;

    const legend4 = svgLegned4.selectAll(id)
      .data(legendText)
      .enter().append('g')
      .attr('class', 'legends4')
      .attr('transform', (d, i) => {
        if (i === 0) {
          dataL = d.length + offset;
          return 'translate(0,0)';
        } else {
          const newdataL = dataL;
          dataL += d.length + offset;
          return 'translate(' + (newdataL) + ',0)';
        }
      });
    legend4.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', 15)
      .attr('height', 10)
      .style('fill', (_d, i) => {
        return color(i);
      });

    legend4.append('text')
      .attr('x', 20)
      .attr('y', 10)
      .text((d) => {
        return d;
      })
      .attr('class', 'textselected')
      .style('text-anchor', 'start')
      .style('font-size', 14);
  }

  circleLegend() {

    const width = 300;
    const height = 170;
    const id = '#' + this.legendConfiguration.id;
    const legendText = d3.set(this.legendData.map(item => item[this.legendConfiguration.textShown])).values();
    const legendColor = d3.set(this.legendData.map(item => item[this.legendConfiguration.color])).values();
    const Svg = d3.select(id).append('svg')
      .attr('width', width)
      .attr('height', height);

    // Usually you have a color scale in your chart already
    const color = d3.scaleOrdinal()
      .domain(legendText)
      .range(legendColor);

    // Add one dot in the legend for each name.
    Svg.selectAll('mydots')
      .data(legendText)
      .enter()
      .append('circle')
      .attr('cx', 90)
      .attr('cy', (_d, i) => 30 + i * 25) // 30 is where the first dot appears. 25 is the distance between dots
      .attr('r', 7)
      .style('fill', (d) => color(d));

    // Add one dot in the legend for each name.
    Svg.selectAll('mylabels')
      .data(legendText)
      .enter()
      .append('text')
      .attr('x', 110)
      .attr('y', (_d, i) => 30 + i * 25) // 30 is where the first dot appears. 25 is the distance between dots
      .style('fill', () => 'black')
      .text((d) => d)
      .attr('text-anchor', 'left')
      .style('alignment-baseline', 'middle');

  }
}
